module.exports = __webpack_public_path__ + "img/logo.b399700d.png";